export const experimentConfig = {
  experimentName: 'Experiment Name',
  controlVariationName: 'Control Variation',
  testVariationName: 'Test Variation',
};
